// orientation
export const FETCH_ORIENTATIONS_INIT = "orientation@FETCH_ORIENTATIONS_INIT"
export const FETCH_ORIENTATIONS_SUCCEDED = "orientation@FETCH_ORIENTATIONS_SUCCEDED"
export const FETCH_ORIENTATIONS_FAILED = "orientation@FETCH_ORIENTATIONS_FAILED"

export const CLEAR_ORIENTATION = "orientation@CLEAR_ORIENTATION"

export const CREATE_ORIENTATION_INIT = "orientation@CREATE_ORIENTATION_INIT"
export const CREATE_ORIENTATION_SUCCEDED = "orientation@CREATE_ORIENTATION_SUCCEDED"
export const CREATE_ORIENTATION_FAILED = "orientation@CREATE_ORIENTATION_FAILED"

export const FETCH_ORIENTATION_INIT = "orientation@FETCH_ORIENTATION_INIT"
export const FETCH_ORIENTATION_SUCCEDED = "orientation@FETCH_ORIENTATION_SUCCEDED"
export const FETCH_ORIENTATION_FAILED = "orientation@FETCH_ORIENTATION_FAILED"

export const EDIT_ORIENTATION_INIT = "orientation@EDIT_ORIENTATION_INIT"
export const EDIT_ORIENTATION_SUCCEDED = "orientation@EDIT_ORIENTATION_SUCCEDED"
export const EDIT_ORIENTATION_FAILED = "orientation@EDIT_ORIENTATION_FAILED"

export const DELETE_ORIENTATION_INIT = "orientation@DELETE_ORIENTATION_INIT"
export const DELETE_ORIENTATION_SUCCEDED = "orientation@DELETE_ORIENTATION_SUCCEDED"
export const DELETE_ORIENTATION_FAILED = "orientation@DELETE_ORIENTATION_FAILED"

export const CLOSE_ORIENTATION_INIT = "orientation@CLOSE_ORIENTATION_INIT"
export const CLOSE_ORIENTATION_SUCCEDED = "orientation@CLOSE_ORIENTATION_SUCCEDED"
export const CLOSE_ORIENTATION_FAILED = "orientation@CLOSE_ORIENTATION_FAILED"